import { CustomLink, Sidebar } from '../entities/Sidebar';
import {
  CLOUD_PAGE,
  CLOUD_PATH,
  EXAMPLES_PAGE,
  EXAMPLES_PATH,
  HARDWARE_PAGE,
  HARDWARE_PATH,
  LEARN_PAGE,
  LEARN_PATH,
  MICROPYTHON_PAGE,
  MYCROPYTHON_PATH,
  RETIRED_PAGE,
  RETIRED_PATH,
  SIDEBAR_CLOUD,
  SIDEBAR_EXAMPLES,
  SIDEBAR_HARDWARE,
  SIDEBAR_IDE_SOFTWARE,
  SIDEBAR_LEARN,
  SIDEBAR_MYCROPYTHON,
  SIDEBAR_PLC_SOFTWARE,
  SIDEBAR_RETIRED,
  SIDEBAR_SOFTWARE,
  SIDEBAR_TUTORIALS,
  SOFTWARE_IDE_PAGE,
  SOFTWARE_IDE_PATH,
  SOFTWARE_PAGE,
  SOFTWARE_PATH,
  SOFTWARE_PLC_PAGE,
  SOFTWARE_PLC_PATH,
  TEMP_HACKING,
  TEMP_LIBRARY_EXAMPLE,
  TUTORIALS_PAGE,
  TUTORIAL_COMMUNICATION,
  TUTORIAL_GENERIC,
  TUTORIAL_NANO_GENERIC,
  TUTORIAL_PROJECT,
  TUTORIAL_SECURITY,
} from './constants';

export function getSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  data.pages.edges.forEach((page) => {
    const nestedCat = [];

    data.pages.edges.forEach((childPage) => {
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        nestedCat.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: page.node.childMdx.frontmatter?.icon || null,
        nestedCategories: [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });

  return refactoredData;
}

export function getRetiredSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  data.pages.edges.forEach((page) => {
    const nestedChild = [];
    const nestedCat = [];

    data.pages.edges.forEach((childPage) => {
      const parts = childPage.node.relativeDirectory.split('/');
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        if (parts[1] === TEMP_LIBRARY_EXAMPLE) {
          if (parts.length === 3) {
            let childs = [];
            data.pages.edges.forEach((libraryChildPage) => {
              const nestedParts = libraryChildPage.node.relativeDirectory.split('/');
              if (nestedParts[1] === TEMP_LIBRARY_EXAMPLE) {
                if (nestedParts.length === 4 && parts[2] === nestedParts[2]) {
                  childs.push({ title: libraryChildPage.node.childMdx.frontmatter.title, url: libraryChildPage.node.fields.slug });
                }
              }
            });
            nestedCat.push({ category: childPage.node.childMdx.frontmatter.title, nestedChildren: childs });
          }
        } else if (parts[1] === TEMP_HACKING) {
          if (parts.length === 3) {
            let childs = [];
            data.pages.edges.forEach((libraryChildPage) => {
              const nestedParts = libraryChildPage.node.relativeDirectory.split('/');
              if (nestedParts[1] === TEMP_HACKING) {
                if (nestedParts.length === 4 && parts[2] === nestedParts[2]) {
                  childs.push({ title: libraryChildPage.node.childMdx.frontmatter.title, url: libraryChildPage.node.fields.slug });
                }
              }
            });
            nestedCat.push({ category: childPage.node.childMdx.frontmatter.title, nestedChildren: childs });
          }
        } else nestedChild.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      if (page.node.relativeDirectory.split('/')[1] === TEMP_LIBRARY_EXAMPLE || page.node.relativeDirectory.split('/')[1] === TEMP_HACKING) {
        refactoredData.push({
          firstLevelCategory: page.node.childMdx.frontmatter.title,
          image: page.node.childMdx.frontmatter?.icon || null,
          nestedCategories: nestedCat,
        });
      } else {
        refactoredData.push({
          firstLevelCategory: page.node.childMdx.frontmatter.title,
          image: page.node.childMdx.frontmatter?.icon || null,
          nestedCategories: [{ category: null, nestedChildren: nestedChild }],
        });
      }
    }
  });

  return refactoredData;
}

export function getSoftwareSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  data.softwarePages.edges.forEach((page) => {
    const nestedCat = [];
    data.softwareSubpages.edges.forEach((subpage) => {
      if (
        page.node.relativeDirectory.length === subpage.node.relativeDirectory.length ||
        subpage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        nestedCat.push({
          title: subpage.node.childMdx.frontmatter.title,
          url: subpage.node.fields.slug,
          description: subpage.node.childMdx.frontmatter.description,
          difficulty: subpage.node.childMdx.frontmatter.difficulty,
        });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: page.node.childMdx.frontmatter.icon,
        nestedCategories: [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });
  return refactoredData;
}

export function getTutorialSideBarDataRefactored(pages: any) {
  let refactoredData: Sidebar[] = [];
  pages.edges.forEach((page) => {
    const nestedCat = [];
    pages.edges.forEach((childPage) => {
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        nestedCat.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: null,
        nestedCategories: [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });

  return refactoredData;
}

export function getTutorialHardwareSideBarDataRefactored(actualPage: string, data: any) {
  let refactoredData: Sidebar[] = [];
  let nestedChild = [];
  data.tutorials.edges.forEach((tutorial) => {
    nestedChild.push({ title: tutorial.node.childMdx.frontmatter.title, url: tutorial.node.fields.slug });
  });

  const nestedCat = [{ category: 'Tutorials', nestedChildren: nestedChild }];

  refactoredData.push({
    firstLevelCategory: actualPage,
    nestedCategories: nestedCat,
  });

  return refactoredData;
}

export function getHardwareSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];

  data?.families.edges.forEach((family) => {
    const categories = data.categories.edges.filter((category) => isInside(category, family));
    const images = imageFor(data?.images, family);

    const nestedCat = categories
      .sort((a, b) => (a.node.relativeDirectory < b.node.relativeDirectory ? -1 : 1))
      .map((category) => {
        const nestedChild = data.products.edges
          .filter((product) => isInside(product, category))
          .sort((a, b) => (a.node.relativeDirectory < b.node.relativeDirectory ? -1 : 1))
          .map((product) => {
            if (product.node.childMdx?.frontmatter?.title) {
              return {
                title: product.node.childMdx.frontmatter.title,
                url: product.node.fields.slug,
              };
            } else return null;
          });
        return { category: category.node.childMdx?.frontmatter.title, nestedChildren: nestedChild };
      });
    if (family.node.childMdx) {
      refactoredData.push({
        firstLevelCategory: family.node?.childMdx?.frontmatter?.title,
        businessUnit: family.node.childMdx.frontmatter.businessUnit,
        anchor: family.node.childMdx.frontmatter.anchor ?? null,
        image: images,
        nestedCategories: nestedCat,
      });
    }
  });

  return refactoredData;
}

export function getCloudSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];

  data.pages.edges.forEach((page) => {
    const parts = page.node.relativeDirectory.split('/');

    const nestedChildren: CustomLink[] = [];
    data.pages.edges.forEach((childPage) => {
      const nestedParts = childPage.node.relativeDirectory.split('/');
      if (nestedParts.length > 2) {
        if (
          page.node.relativeDirectory.length !== childPage.node.relativeDirectory.length &&
          childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) !== -1
        ) {
          nestedChildren.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
        }
      }
    });

    if (parts.length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: page.node.childMdx.frontmatter.icon,
        nestedCategories: [
          {
            nestedChildren,
          },
        ],
      });
    }
  });

  return refactoredData;
}

export function getLanguageReferenceSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  let subCategoriesList = [];

  data?.pages.edges.forEach((page) => {
    if (page.node.childMdx.frontmatter.subCategories && !subCategoriesList.includes(page.node.childMdx.frontmatter.subCategories)) {
      subCategoriesList.push(page.node.childMdx.frontmatter.subCategories);
    }
  });

  data?.pages.edges.forEach((page) => {
    const parts = page.node.relativeDirectory.split('/');

    const nestedCat = subCategoriesList.map((category) => {
      const nestedChild: CustomLink[] = data.pages.edges
        .filter((product) => isInsideSubCategory(product, category, page.node.childMdx.frontmatter.title))
        .map((leaf) => {
          return {
            title: leaf.node.childMdx.frontmatter.title,
            url: leaf.node.fields.slug,
          };
        });
      return { category: nestedChild.length > 0 ? category : null, nestedChildren: nestedChild };
    });

    if (parts.length !== 2) return null;

    refactoredData.push({
      firstLevelCategory: page.node.childMdx.frontmatter.title,
      image: null,
      nestedCategories: nestedCat,
    });
  });

  return refactoredData;
}

export function getMicropythonSideBarDataRefactored(data: any, images?: any) {
  let refactoredData: Sidebar[] = [];

  data.micropythonPages.edges.forEach((page) => {
    const nestedCat = [];

    const micropython101Courses = [];
    const micropython101Project = [];

    data.micropythonPages.edges.forEach((childPage) => {
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        if (images) {
          let img = null;
          images.edges.forEach((image) => {
            //If there is no image inside the folder, it does not enter and insert the folder in the sidebar
            if (image.node.relativeDirectory === childPage.node.relativeDirectory) {
              img = image.node.childImageSharp;

              nestedCat.push({
                title: childPage.node.childMdx.frontmatter.title,
                description: childPage.node.childMdx.frontmatter.description,
                url: childPage.node.fields.slug,
                author: childPage.node.childMdx.frontmatter.author,
                date: childPage.node.fields.gitLogLatestDate,
                image: img,
              });
              return;
            }
          });
        } else {
          nestedCat.push({
            title: childPage.node.childMdx.frontmatter.title,
            description: childPage.node.childMdx.frontmatter.description,
            url: childPage.node.fields.slug,
            author: childPage.node.childMdx.frontmatter.author,
            date: childPage.node.fields.gitLogLatestDate,
          });
        }
      }
    });

    // micropythonCourses
    data.micropythonPages.edges.forEach((childPage) => {
      if (childPage.node.relativeDirectory.split('/').includes('02.micropython-course')) {
        if (childPage.node.relativeDirectory.split('/').includes('course')) {
          if (images) {
            let img = null;
            images.edges.forEach((image) => {
              if (image.node.relativeDirectory === childPage.node.relativeDirectory) {
                img = image.node.childImageSharp;

                micropython101Courses.push({
                  title: childPage.node.childMdx.frontmatter.title,
                  description: childPage.node.childMdx.frontmatter.description,
                  url: childPage.node.fields.slug,
                  author: childPage.node.childMdx.frontmatter.author,
                  date: childPage.node.fields.gitLogLatestDate,
                  image: img,
                });
                return;
              }
            });
          } else {
            micropython101Courses.push({
              title: childPage.node.childMdx.frontmatter.title,
              description: childPage.node.childMdx.frontmatter.description,
              url: childPage.node.fields.slug,
              author: childPage.node.childMdx.frontmatter.author,
              date: childPage.node.fields.gitLogLatestDate,
            });
          }
        } else if (childPage.node.relativeDirectory.split('/').includes('projects')) {
          if (images) {
            let img = null;
            images.edges.forEach((image) => {
              if (image.node.relativeDirectory === childPage.node.relativeDirectory) {
                img = image.node.childImageSharp;
                micropython101Project.push({
                  title: childPage.node.childMdx.frontmatter.title,
                  description: childPage.node.childMdx.frontmatter.description,
                  url: childPage.node.fields.slug,
                  author: childPage.node.childMdx.frontmatter.author,
                  date: childPage.node.fields.gitLogLatestDate,
                  image: img,
                });
                return;
              }
            });
          }
        }
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        firstLevelCategoryDescription: page.node.childMdx.frontmatter?.description || null,
        image: page.node.childMdx.frontmatter?.icon || null,
        nestedCategories:
          page.node.childMdx.frontmatter.title === 'MicroPython 101 Course'
            ? [
                { category: 'Courses', nestedChildren: micropython101Courses },
                { category: 'Projects', nestedChildren: micropython101Project },
              ]
            : [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });

  return refactoredData;
}

export function isInside(element, container) {
  const index = element.node.relativeDirectory.indexOf(container.node.relativeDirectory);

  return index !== -1;
}

export function isInsideSubCategory(element, container, mainCategory) {
  if (element.node.childMdx.frontmatter.subCategories === container && element.node.childMdx.frontmatter.categories === mainCategory) {
    return true;
  }
  return false;
}

export function imageFor(images, family) {
  if (!images) return null;
  return images.edges.filter((image) => {
    return image.node.relativeDirectory === family.node.relativeDirectory;
  });
}

export function getActualPage(parts) {
  if (parts[1] === CLOUD_PATH) return { title: SIDEBAR_CLOUD, url: CLOUD_PAGE };
  else if (parts[1] === HARDWARE_PATH) {
    if (
      parts[2] === TUTORIAL_COMMUNICATION ||
      parts[2] === TUTORIAL_GENERIC ||
      parts[2] === TUTORIAL_PROJECT ||
      parts[2] === TUTORIAL_NANO_GENERIC ||
      parts[2] === TUTORIAL_SECURITY
    )
      return { title: SIDEBAR_TUTORIALS, url: TUTORIALS_PAGE };
    else return { title: SIDEBAR_HARDWARE, url: HARDWARE_PAGE + parts[parts.length - 3] };
  } else if (parts[1] === SOFTWARE_PATH) {
    if (parts[2] === SOFTWARE_IDE_PATH) return { title: SIDEBAR_IDE_SOFTWARE, url: SOFTWARE_IDE_PAGE };
    else if (parts[2] === SOFTWARE_PLC_PATH) return { title: SIDEBAR_PLC_SOFTWARE, url: SOFTWARE_PLC_PAGE };
    else return { title: SIDEBAR_SOFTWARE, url: SOFTWARE_PAGE };
  } else if (parts[1] === LEARN_PATH) return { title: SIDEBAR_LEARN, url: LEARN_PAGE };
  else if (parts[1] === MYCROPYTHON_PATH) return { title: SIDEBAR_MYCROPYTHON, url: MICROPYTHON_PAGE };
  else if (parts[1] === EXAMPLES_PATH) return { title: SIDEBAR_EXAMPLES, url: EXAMPLES_PAGE };
  if (parts[1] === RETIRED_PATH) return { title: SIDEBAR_RETIRED, url: RETIRED_PAGE };
  else return { title: 'All docs', url: '/' };
}
